module.exports = __webpack_public_path__ + "media/application/images/ui/icon-yes-tick-1f8d6904bf13173d18fa59e27a6850ce.svg";